var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-form',{attrs:{"form":_vm.form,"label-col":{ span: 6 },"wrapper-col":{ span: 16 }}},[_c('a-form-item',{attrs:{"label":"对象租户"}},[_c('a-input',{attrs:{"value":_vm.app.appCode,"placeholder":"请输入对象租户","disabled":true}})],1),_c('a-form-item',{attrs:{"label":"APP名称"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
        'appDisplayName',
        {
          initialValue: _vm.app.appDisplayName
        }
      ]),expression:"[\n        'appDisplayName',\n        {\n          initialValue: app.appDisplayName\n        }\n      ]"}],attrs:{"placeholder":"请输入APP名称","disabled":true}})],1),_c('a-form-item',{attrs:{"label":"APP编号"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
        'appCode',
        {
          initialValue: _vm.app.appCode
        }
      ]),expression:"[\n        'appCode',\n        {\n          initialValue: app.appCode\n        }\n      ]"}],attrs:{"placeholder":"请输入APP编号","disabled":""}})],1),_c('a-form-item',{attrs:{"label":"APP序号"}},[_c('a-input-number',{directives:[{name:"decorator",rawName:"v-decorator",value:([
        'sort',
        {
          initialValue: _vm.app.sort,
          rules: [{ required: true, message: '请输入APP序号' }]
        }
      ]),expression:"[\n        'sort',\n        {\n          initialValue: app.sort,\n          rules: [{ required: true, message: '请输入APP序号' }]\n        }\n      ]"}],staticStyle:{"width":"100%"},attrs:{"placeholder":"请输入APP序号","min":0,"max":99}})],1),_c('a-form-item',{attrs:{"label":"授权到期时间"}},[_c('a-date-picker',{directives:[{name:"decorator",rawName:"v-decorator",value:([
        'expireTime',
        {
          rules: [
            { required: true, message: '请选择授权到期时间' },
            {
              validator: _vm.timeValidator
            }
          ],
          initialValue: _vm.moment(_vm.app.expireTime)
        }
      ]),expression:"[\n        'expireTime',\n        {\n          rules: [\n            { required: true, message: '请选择授权到期时间' },\n            {\n              validator: timeValidator\n            }\n          ],\n          initialValue: moment(app.expireTime)\n        }\n      ]"}],attrs:{"placeholder":"请选择授权到期时间","showTime":""}})],1),_c('div',{style:({
      position: 'absolute',
      right: 0,
      bottom: 0,
      width: '100%',
      borderTop: '1px solid #e9e9e9',
      padding: '10px 16px',
      background: '#fff',
      textAlign: 'right',
      zIndex: 1
    })},[_c('a-form-item',{staticStyle:{"text-align":"right","margin":"0"},attrs:{"wrapper-col":{ span: 24 }}},[_c('a-button',{attrs:{"type":"primary","loading":_vm.loading},on:{"click":_vm.save}},[_vm._v(" 保存 ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }